/**
 * Cliente HTTP para gestion de fotos post-upload. Sprint 20-B.
 *
 * El upload inicial vive en `assessments.photos.upload` (POST multipart).
 * Aqui solo exponemos operaciones que requieren el id ya conocido:
 *   - patchApplicableStandards: actualiza el tagging IMS de la foto
 *     (S16-B introdujo applicable_standards, S20-B agrega la UI).
 */
import { apiRequest } from './client.js';

export interface PhotoTagsResponse {
  photo: {
    id: string;
    question_ref: string;
    applicable_standards: string[];
  };
}

export const photosApi = {
  /**
   * PATCH /api/v1/photos/:id — actualiza applicable_standards de la foto.
   * `standards` puede ser array vacio para limpiar el tagging.
   */
  patchApplicableStandards: (id: string, standards: string[]) =>
    apiRequest<PhotoTagsResponse>(`/api/v1/photos/${id}`, {
      method: 'PATCH',
      body: { applicable_standards: standards },
    }),
};
